import { useEffect } from 'react'

export function useOnClickOutside(ref, handler, custom_selector) {
    useEffect(() => {
        const listener = (event) => {
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || ref.current.contains(event.target)) {
                return
            }

            if (custom_selector && event.target.id === custom_selector) return
            handler(event)
        }

        document.addEventListener('mousedown', listener)
        document.addEventListener('touchstart', listener)

        return () => {
            document.removeEventListener('mousedown', listener)
            document.removeEventListener('touchstart', listener)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref, handler])
}
